module.exports = __webpack_public_path__ + "img/Leaving no one behind in Vietnam_s energy transition.b03f6a7a.png";